import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService, ConfirmOptions } from '../../services/notification.service';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="visible" class="overlay" (click)="onCancel()">
      <div class="dialog" (click)="$event.stopPropagation()">
        <h3>{{ options.title }}</h3>
        <p>{{ options.message }}</p>
        <div class="dialog-actions">
          <button class="btn-cancel" (click)="onCancel()">{{ options.cancelText || 'Cancel' }}</button>
          <button [class]="options.danger ? 'btn-danger' : 'btn-confirm'" (click)="onConfirm()">{{ options.confirmText || 'Confirm' }}</button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.4); z-index: 10000; display: flex; align-items: center; justify-content: center; animation: fadeIn 0.15s; }
    .dialog { background: white; border-radius: 8px; padding: 28px 32px; max-width: 440px; width: 90%; box-shadow: 0 8px 32px rgba(0,0,0,0.2); }
    .dialog h3 { margin: 0 0 12px; color: #2F5496; font-size: 17px; }
    .dialog p { margin: 0 0 20px; color: #333; font-size: 14px; line-height: 1.5; }
    .dialog-actions { display: flex; justify-content: flex-end; gap: 10px; }
    .btn-cancel { background: #eee; border: 1px solid #ccc; padding: 8px 18px; border-radius: 4px; cursor: pointer; font-size: 13px; }
    .btn-confirm { background: #2F5496; color: white; border: none; padding: 8px 18px; border-radius: 4px; cursor: pointer; font-size: 13px; font-weight: 600; }
    .btn-danger { background: #c62828; color: white; border: none; padding: 8px 18px; border-radius: 4px; cursor: pointer; font-size: 13px; font-weight: 600; }
    @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
  `]
})
export class ConfirmDialogComponent {
  visible = false;
  options: ConfirmOptions = { title: '', message: '' };
  private resolveFn: ((result: boolean) => void) | null = null;

  constructor(private notifications: NotificationService) {
    this.notifications.confirm$.subscribe(data => {
      if (data) {
        this.options = data.options;
        this.resolveFn = data.resolve;
        this.visible = true;
      }
    });
  }

  onConfirm() {
    this.visible = false;
    this.resolveFn?.(true);
    this.notifications.confirm$.next(null);
  }

  onCancel() {
    this.visible = false;
    this.resolveFn?.(false);
    this.notifications.confirm$.next(null);
  }
}
